import { updateMonitorParameter } from "@/api/monitor-object/monitor-parameter";
import { Emit_Event } from "@/enums/emit-event";
import TnInput from "@/global/components/input/tn-input";
import TnMessage from "@/global/components/message";
import { MonitorParameter } from "@/global/interface/monitor-object/monitor-parameter";
import { emitter } from "@/global/listeners";
import { Transfer2BackEndScale, Transfer2DisplayScale } from "@/global/utils/unit-type";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

interface Iprops {
    param: MonitorParameter
    onUpdateParam: (id:number,param: MonitorParameter) => void
}

export default function MonitorParameterWarningSetting(props: Iprops) {
    const { param } = props;
    const [item, setItem] = useState<MonitorParameter>();

    useEffect(() => {
        if (!param) return;
        // 将参数阈值转成显示单位下的值，需乘的系数
        let scale = Transfer2DisplayScale(param.unit);
        setItem({
            ...param,
            t2Dis: param.t2 != null ? scale * param.t2 : null,
            t3Dis: param.t3 != null ? scale * param.t3 : null,
            t4Dis: param.t4 != null ? scale * param.t4 : null,
        });
    }, [param])

    // 更新参数阈值
    const updateParameter = (id: number, data) => {
        updateMonitorParameter(id, data).then(res => {
            TnMessage.success("更新成功");
            emitter.emit(Emit_Event.LINE_CHART_UPDATE)
            props.onUpdateParam(id,data);
        }).catch(err => {
            TnMessage.error("更新失败");
        })
    }

    if (!item) {
        return (
            <div></div>
        )
    }

    return (
        <div className="param">
            <div className="name ellipsis" title={`${item.name}${item.unit || ''}`}>{item.name}{item.unit || ''}</div>
            <div className="cell"><TnInput
                className="blue-input"
                value={item.t2Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t2Dis: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t2 = scale * (+value)
                        updateParameter(item.id, { t2: t2 })
                    }
                }}
            /></div>
            <div className="cell sec"><TnInput
                className="blue-input"
                value={item.t3Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t3Dis: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t3 = scale * (+value)
                        updateParameter(item.id, { t3: t3 })
                    }
                }}
            /></div>
            <div className="cell third"><TnInput
                className="blue-input"
                value={item.t4Dis}
                onTextChange={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        setItem({ ...item, t4Dis: value })
                    }
                }}
                onBlur={(value) => {
                    const reg = /^-?\d*(\.\d*)?$/;
                    if ((!isNaN(+value) && reg.test(value)) || value === '' || value === '-') {
                        let scale = Transfer2BackEndScale(item.unit);
                        let t4 = scale * (+value)
                        updateParameter(item.id, { t4: t4 })
                    }
                }}
            /></div>
        </div>
    )
}